import { render, staticRenderFns } from "./Sichtschutz.vue?vue&type=template&id=617e0ee9&"
import script from "./Sichtschutz.vue?vue&type=script&lang=js&"
export * from "./Sichtschutz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports